import { type Configuration, LogLevel } from '@blattnercompany/react-auth'

import { logger } from '@/utils/logger'

import { env, msalEnv as msal } from './env'

const log = logger.scoped('msal')

/**
 * MSAL configuration for Microsoft Entra ID authentication.
 * Values come from the validated env module (configs/env.ts).
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: msal.clientId,
    authority: `${msal.authorityBase}${msal.tenantId}`,
    redirectUri: msal.redirectUrl,
    // Same registered URI as redirectUri: Entra only honors registered
    // post-logout URIs, and the page origin may not be one.
    postLogoutRedirectUri: msal.redirectUrl,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      // Through the logger wrapper, not console.* (React_TypeScript_Standards §6.2).
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return
        switch (level) {
          case LogLevel.Error:
            log.error(message)
            break
          case LogLevel.Warning:
            log.warn(message)
            break
          case LogLevel.Info:
          case LogLevel.Verbose:
            log.info(message)
            break
        }
      },
      logLevel: env.isDev ? LogLevel.Verbose : LogLevel.Error,
      piiLoggingEnabled: false,
    },
  },
}

/**
 * Scopes for StagehandAPI access, shared by `<AuthProvider>` and the token
 * interceptor so both ask for the same thing. `openid`/`profile`/`email` are
 * omitted deliberately — MSAL adds them to every request itself.
 */
export const apiScopes = [msal.apiScope]
